import { styled, useTheme } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";

const StyledMain = styled("main", {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "drawerWidth",
})(({ theme, open, drawerWidth }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: 'var(--bg-main)',
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}));

export function Main({ open, drawerWidth, children }) {
  return (
    <StyledMain open={open} drawerWidth={drawerWidth}>
      {children}
    </StyledMain>
  );
}

const StyledAppBar = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1f1f1f' : '#f8fafb',
  boxShadow: 'none',
  color: theme.palette.mode === 'dark' ? '#e8eaed' : '#202124',
  position: 'static',
  flexShrink: 0,
}));

export function AppBar({ children }) {
  return (
    <StyledAppBar>
      {children}
    </StyledAppBar>
  );
}

export const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1, 1.25),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "center",
  minHeight: '52px',
}));
